export const INTRODUCTION_ROW_HEIGHT = "48px";
export const CONTAINER_MIN_HEIGHT = "72px";
export const TIMESTAMP_WIDTH = 2.6;
export const CUSTOMER_NAME_WIDTH = 5.9;
export const STATUS_WIDTH = 2.5;
export const ACTION_WIDTH = 1;
